import type { PluginOption } from 'vite';
import type { ProjectModel } from '../../model.js';
import {
  virtualSiteComponentScriptAssets,
  virtualSiteComponentPreviewScriptAssets,
  virtualSiteComponentPanelScriptAssets,
} from '../../dev-center/components/site/config.js';

interface Options {
  initialModel: ProjectModel;
}

export const EXPORTS_CUSTODIAN_ENTRY = 'virtual:wix-exports-custodian-entry';

export const preserveSiteComponentPanelsExports = ({
  initialModel,
}: Options): PluginOption => {
  const virtualSiteComponentPanelAssets =
    virtualSiteComponentPanelScriptAssets(initialModel);

  return {
    name: 'wix:site-components:preserve-exports-panels',
    apply: 'build',
    resolveId(id) {
      if (id === EXPORTS_CUSTODIAN_ENTRY) {
        return id;
      }

      return null;
    },
    load(id) {
      if (id === EXPORTS_CUSTODIAN_ENTRY) {
        return [...virtualSiteComponentPanelAssets.keys()]
          .map((path) => `import('${path}');`)
          .join('\n');
      }

      return null;
    },
  };
};

export const preserveSiteComponentComponentsExports = ({
  initialModel,
}: Options): PluginOption => {
  const virtualSiteComponentAssets =
    virtualSiteComponentScriptAssets(initialModel);
  const virtualSiteComponentPreviewAssets =
    virtualSiteComponentPreviewScriptAssets(initialModel);
  return {
    name: 'wix:site-components:preserve-exports-components',
    apply: 'build',
    resolveId(id) {
      if (id === EXPORTS_CUSTODIAN_ENTRY) {
        return id;
      }

      return null;
    },
    load(id) {
      if (id === EXPORTS_CUSTODIAN_ENTRY) {
        return [
          ...virtualSiteComponentPreviewAssets.keys(),
          ...virtualSiteComponentAssets.keys(),
        ]
          .map((path) => `import('${path}');`)
          .join('\n');
      }

      return null;
    },
  };
};
